import styled from "styled-components";

export const StyledAppIcon = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  & img {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }
`;
